import type { DerivedAction } from '../lib/types'
import { ActionCard } from './ActionCard'

export function DerivedActionChecklist({
  actions,
  reportId,
}: {
  actions: DerivedAction[]
  reportId: string
}) {
  if (actions.length === 0) return null

  return (
    <div className="mt-4">
      <h4 className="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-500">
        Ações derivadas
      </h4>
      <div className="space-y-2">
        {actions.map((a) => (
          <ActionCard key={a.id} action={a} kind="derived" reportId={reportId} />
        ))}
      </div>
    </div>
  )
}
